import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MetricsGallery from '../metrics_gallery';
import {
  getCurrentProvider,
  providers
} from '../../../../../services/provider/getCurrentProvider';
import useSettings from '../../../../../libs/settings/useSettings';
import { DEFAULT_MAIN_KPI } from '../../metric_detail/metric_detail_header/kpi_dropdown/services';
import {
  getAllMetrics,
  prepareInsights
} from '../../../../../redux/overview/metrics/metricsActions';
import { getCurrentLabel } from '../../../../../redux/app/appActions';
import {
  getOverviewDMPreferences,
  getVrrPreferences
} from '../../../../../redux/settings/settingAction';
import {
  TMetricKey,
  TSetOfMetrics
} from '../../../../../redux/overview/metrics/types';
import { TDateRange } from '../../../../nav_bar/date_time_picker/types';
import { TDetailedMetricsInitialState } from '../../../../../redux/settings/types';

const Metrics: React.FC = () => {
  const dispatch: any = useDispatch();
  const allMetrics: TSetOfMetrics = useSelector(getAllMetrics);
  const period: TDateRange | undefined = useSelector(getVrrPreferences)?.period;
  const funnel: string = useSelector(getCurrentLabel);
  const accountId = useSelector(getVrrPreferences)?.current_account_id;
  const brandId = useSelector(getVrrPreferences)?.current_brand_id;
  const currentMetricsSettings: TDetailedMetricsInitialState | undefined =
    useSelector(getOverviewDMPreferences);
  const [currentBrand, setCurrentBrand] = useState('');
  const [currentFunnel, setCurrentFunnel] = useState(funnel);
  const [currentPeriod, setCurrentPeriod] = useState(period);
  const [provider, setProvider] = useState('all');
  const { overview } = useSettings();

  useEffect(() => {
    const currentProvider = getCurrentProvider();
    if (providers.includes(currentProvider)) {
      setProvider(currentProvider);
    }
  }, []);

  useEffect(() => {
    if (
      currentBrand !== '' &&
      currentFunnel &&
      currentPeriod?.from &&
      currentPeriod?.to &&
      provider !== ''
    ) {
      dispatch(
        prepareInsights({
          brandId: currentBrand,
          period: currentPeriod,
          provider
        })
      );
    }
  }, [currentBrand, currentFunnel, currentPeriod, provider]);

  useEffect(() => {
    if (
      accountId !== undefined &&
      brandId &&
      (currentBrand !== brandId ||
        currentFunnel !== funnel ||
        (currentPeriod?.from !== period?.from &&
          currentPeriod?.to !== period?.to))
    ) {
      setCurrentBrand(brandId);
      setCurrentFunnel(funnel);
      setCurrentPeriod(period);
      if (!currentMetricsSettings && accountId !== '') {
        overview('detailed_metrics', {
          main_kpi: DEFAULT_MAIN_KPI
        });
      }
    }
  }, [accountId, brandId, funnel, period, currentMetricsSettings]);

  return (
    <MetricsGallery
      mainKpi={currentMetricsSettings?.main_kpi}
      metricsList={allMetrics}
      currentMetrics={
        (currentMetricsSettings?.displayed_dimensions as TMetricKey[]) ?? [
          'video'
        ]
      }
    />
  );
};

export default Metrics;
